import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AddDisbursementPayloadType } from "../../commonTypes/disbursementsTypes";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
} from "../../components/commons";
import { AddEditDisbursementForm } from "../../components/DisbursementModule/DisbursementModuleForm";
import { resetSession } from "../../redux/auth";
import {
  addDisbursementsAction,
  resetDisbursementsError,
  resetDisbursementsMessage,
  resetDisbursementsStatusCode,
  resetDisbursementsSuccess,
} from "../../redux/disbursements";
import { RootState } from "../../redux/rootReducers";
import { handleDate } from "../../utils/commonFunctions";
type AppProps = {
  history: any;
  token: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  dispatchResetDisbursementsSuccess: () => void;
  dispatchResetDisbursementsError: () => void;
  dispatchResetDisbursementsMessage: () => void;
  dispatchResetDisbursementsStatusCode: () => void;
  dispatchAddDisbursementsAction: (data: AddDisbursementPayloadType) => void;
  dispatchResetSession: () => void;
};
const AddDisbursement = ({
  history,
  token,
  statusCode,
  success,
  error,
  dispatchResetDisbursementsSuccess,
  dispatchResetDisbursementsError,
  dispatchResetDisbursementsMessage,
  dispatchResetDisbursementsStatusCode,
  dispatchResetSession,
  dispatchAddDisbursementsAction,
}: AppProps) => {
  const tab = history?.location?.state?.activeTab;
  const [date, setDate] = useState(null);
  const handleDateChange = (date: any) => {
    const value = handleDate(date);
    setDate(value);
  };
  useEffect(() => {
    dispatchResetDisbursementsSuccess();
    dispatchResetDisbursementsError();
    dispatchResetDisbursementsMessage();
    dispatchResetDisbursementsStatusCode();
  }, []);
  const handleAddDisbursements = (data: AddDisbursementPayloadType) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddDisbursementsAction(finalData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetDisbursementsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Disbursement Added Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetDisbursementsSuccess();
            history?.goBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };
  return (
    <>
      <CommonHeader title="Add Disbursement" />
      <ContentArea>
        <AddEditDisbursementForm
          history={history}
          date={date}
          tab={tab}
          setDate={setDate}
          handleDateChange={handleDateChange}
          handleAddDisbursements={handleAddDisbursements}
        />
      </ContentArea>
      {handleErrorModal()}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.disbursements.success,
  statusCode: state.disbursements.statusCode,
  error: state.disbursements.error,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetDisbursementsSuccess: () =>
    dispatch(resetDisbursementsSuccess()),
  dispatchResetDisbursementsError: () => dispatch(resetDisbursementsError()),
  dispatchResetDisbursementsMessage: () =>
    dispatch(resetDisbursementsMessage()),
  dispatchResetDisbursementsStatusCode: () =>
    dispatch(resetDisbursementsStatusCode()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchAddDisbursementsAction: (data: AddDisbursementPayloadType) =>
    dispatch(addDisbursementsAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDisbursement);
